/*
Вспомогательный класс для обработки даных онтологии
*/
import getOntology from './ontology';
import i18n from 'i18next';

class OntologyHelper {

	constructor(ontology) {
		//this.data = ontology;
		this.data = getOntology();
	}

	getClasses() {
		return this.data.classes;
	}

	getClass(class_id) {
		const cls = this.data.classes.find( (e) => e.id === class_id);
		if (cls) {
			return cls;
		} else {
			throw 'Class not found: ' + class_id;
		}
	}

	markAsHidden(item) {
		return item['hide_in_list'] === 'true' ? i18n.t('ontology.common.hidden_suffix') : '';
	}

	getViewTitle(item) {
		return item['view_title'];
	}

	getViewDescription(item) {
		return item['view_description'];
	}

	getViewEndpoint(item) {
		return item['src_endpoint'];
	}

	getViewQuery(item) {
		return item['src_query'];
	}

	getComment(prop) {
		return prop.comment;
	}

	isEditable(prop) {
		return prop.editable !== false;
	}

	isMultiline(prop) {
		return prop.restriction ? prop.restriction.multiline : false;
	}

	isUnique(prop) {
		return prop.restriction  ? prop.restriction.unique : false;
	}

	isOptional(prop) {
		return prop.restriction  ? prop.restriction.optional : false;
	}

	isObjectProperty(prop) {
		return prop.type === 'object';
	}

	getMinCardinality(prop) {
		const r = prop.restriction;
		if (! r) {
			return 0;
		}
		if ('minCardinality' in r) {
			return r.minCardinality;
		}
		if ('cardinality' in r) {
			return r.cardinality;
		}
		return 0;
	}

	getMaxCardinality(prop) {
		const r = prop.restriction;
		if (! r) {
			return Infinity;
		}
		if ('maxCardinality' in r) {
			return r.maxCardinality;
		}
		if ('cardinality' in r) {
			return r.cardinality;
		}
		return Infinity;
	}

	//Отображать параметры в строку
	getInLine(prop) {
		const r = prop.restriction;
		if (! r) {
			return false;
		}
		if ('inLine' in r) {
			return r.inLine;
		}
		return false;
	}

	//Получить информацию о стиле в bootstrap.css
	getBootstrap(prop) {
		const r = prop.bootstrap;
		if (!r) {
			return "";
		}
		return r;
	}


	// есть ли список фикс значений
	getEnumValues(prop) {
		const r = prop.restriction;
		return r ? r.enumeration : null;
	}

	getEnumSelectSize(prop) {
		const r = prop.restriction;
		return r && 'selectSize' in r ? r.selectSize : 0;
	}

	getFillType(prop) {
		return prop.hasOwnProperty('fill') ? prop.fill : null;
	}

	isColumsProperty(prop) {
		return prop.id === 'col';
	}

	getColumsProperty(class_id) {
		return this.getClass(class_id).props.find( (e) => e.id === 'col');
	}

	// создать пустой объект view указанного класса
	createInstance(cls) {
		const item = this.createObject(cls.props, true);
		item.type = cls.id;
		return item;
	}

	// создать объект с указанным набором свойств 
	createObject(props) {
		const item =  {};
		props.map((p) => (this.createProperty(item, p)));
		return item;
	}

	// добавляем все обязательные свойства и дефолтные значения
	createProperty(item, prop) {
		const min = this.getMinCardinality(prop);
		if (min === 0) {
			//2026-04-19 Для 'object' надо создать пустой объект, что-бы вложенные свойства срабатывали
			//Иначе ошибка при редактировании 
			if (prop.type === 'object')
				item[prop.id] = this.createValue(prop);
			return;
		}
		const max = this.getMaxCardinality(prop);
		const value = [];
		if (! this.isColumsProperty(prop)) {
			for (let i = 0; i < min; i++) {
				value[i] = this.createValue(prop);
			}
		}
		item[prop.id] = (max === 1) ? value[0] : value;
	}

	// одно значение (объект или данные) для указанного свойства
	// возвращает одно значение, даже если свойство множественное 
	createValue(prop) {
		if (this.isObjectProperty(prop)) {
			return this.createObject(prop.props);
		} else {
			return prop.default;
		}
	}

	createColumns(prop, object_cols, fields) {
		let old_cols = [];
		for(let i = 0; i < object_cols.length; i++) {
			const col = object_cols[i];
			old_cols[col.col_field] = col;
		}
		const show = (fields.length === 1) ? 0 : 1;
		return fields.map((field, index) => {
			if (old_cols[field.field] !== undefined) {
				return old_cols[field.field];
			} else {
				const col = this.createValue(prop);
				// noinspection JSUnresolvedVariable
				col.col_field = field.field;
				col.col_data = field.data;
				col.col_uri = (index === 0) ? 'true' : 'false';
				col.col_show = (index === show) ? 'true' : 'false';
				if ('alpha_col' in col) {
					col.alpha_col = (index === 0) ? 'true' : 'false';
				}
				if ('col_title' in col) {
					col.col_title = col.col_field;
				}
				return col;
			}
		});
	}

}

export default OntologyHelper;
